/* FoodQual Theme JS — Naume Tech */

/* ── Search ── */
function updateSearchCollection(select) {
  // Store selected collection for use on submit
  window._selectedCollection = select.value;
}

function submitSearch(event) {
  if (event) event.preventDefault();
  const q = document.getElementById('search-input').value.trim();
  if (!q) return;
  const collection = window._selectedCollection || '';
  if (collection) {
    // Redirect to collection page with search filter
    window.location.href = '/collections/' + collection + '?q=' + encodeURIComponent(q);
  } else {
    // Global search
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }
}

/* ── Cart ── */
function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function addToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: parseInt(quantity) || 1 })
  })
  .then(r => r.json())
  .then(() => {
    updateCartCount();
    refreshCartDrawer();
    openCart();
  })
  .catch(console.error);
}

function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(r => r.json())
  .then(() => { updateCartCount(); refreshCartDrawer(); })
  .catch(console.error);
}

function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.getElementById('cartCount');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const body = document.getElementById('cartDrawerBody');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div class="fq-cart-empty">
            <p>Your basket is empty</p>
            <a href="/collections/all" class="fq-btn fq-btn--primary">Start shopping</a>
          </div>`;
        return;
      }

      let html = '';
      cart.items.forEach(item => {
        html += `
          <div class="fq-cart-item">
            <img src="${item.image}" alt="${item.title}" width="60" height="60"
                 style="border-radius:6px;object-fit:cover;flex-shrink:0;">
            <div class="fq-cart-item__info">
              <p class="fq-cart-item__name">${item.product_title}</p>
              <p class="fq-cart-item__vendor">${item.vendor}</p>
              <p class="fq-cart-item__price">${formatMoney(item.final_price)}</p>
            </div>
            <div class="fq-cart-item__qty">
              <button class="fq-qty-btn" onclick="updateCart('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button class="fq-qty-btn" onclick="updateCart('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>`;
      });

      body.innerHTML = html;

      const footer = document.querySelector('.fq-cart-drawer__footer .fq-cart-total span:last-child');
      if (footer) footer.textContent = formatMoney(cart.total_price);
    })
  .catch(console.error);
}

function formatMoney(cents) {
  return 'R ' + (cents / 100).toFixed(2);
}

/* ── Product Carousel ── */
function slideCarousel(id, direction) {
  const track = document.getElementById(id);
  if (!track) return;
  const card = track.firstElementChild;
  if (!card) return;
  let cardWidth = card.offsetWidth + 16;
  if (id.indexOf('farmers-track') === 0) {
    cardWidth = cardWidth * 3;
  }
  const currentTranslate = parseInt(track.dataset.translate || 0);
  const maxTranslate = -(track.scrollWidth - track.parentElement.offsetWidth);
  const newTranslate = Math.min(0, Math.max(maxTranslate, currentTranslate - (direction * cardWidth)));
  track.dataset.translate = newTranslate;
  track.style.transform = 'translateX(' + newTranslate + 'px)';
}

/* ── Mega Menu ── */
document.querySelectorAll('.fq-nav-item').forEach(item => {
  item.addEventListener('click', function(e) {
    const mega = this.querySelector('.fq-mega-menu');
    if (mega) {
      e.stopPropagation();
      document.querySelectorAll('.fq-mega-menu').forEach(m => {
        if (m !== mega) m.parentElement.classList.remove('active');
      });
      this.classList.toggle('active');
    }
  });
});

document.addEventListener('click', () => {
  document.querySelectorAll('.fq-nav-item').forEach(item => {
    item.classList.remove('active');
  });
});

/* ── Mobile Menu ── */
function openMobileMenu() {
  document.getElementById('mobileMenu').classList.add('open');
  document.getElementById('mobileOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  document.getElementById('mobileMenu').classList.remove('open');
  document.getElementById('mobileOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Countdown Timer ── */
function initCountdown(endDateStr) {
  if (!endDateStr) return;
  const endDate = new Date(endDateStr).getTime();
  const tick = () => {
    const now = new Date().getTime();
    const diff = endDate - now;
    if (diff <= 0) return;
    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const s = Math.floor((diff % (1000 * 60)) / 1000);
    const pad = n => String(n).padStart(2, '0');
    const el = id => document.getElementById(id);
    if (el('cd-days')) el('cd-days').textContent = pad(d);
    if (el('cd-hours')) el('cd-hours').textContent = pad(h);
    if (el('cd-mins')) el('cd-mins').textContent = pad(m);
    if (el('cd-secs')) el('cd-secs').textContent = pad(s);
  };
  tick();
  setInterval(tick, 1000);
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  const countdownDate = document.getElementById('countdownDate');
  if (countdownDate) initCountdown(countdownDate.dataset.date);
});

window.addEventListener('load', updateCartCount);
